import { Button, DropdownToggle } from "@doar/components";
import styled, { css, themeGet } from "@doar/shared/styled";

export const StyledActionButtons = styled.div`
    position: relative;
    margin-left: auto;
`;

export const StyledSpinnerWrapper = styled.div`
    position: absolute;
    right: 15px;
    top: 20px;
`;

export const StyledSearchInput = styled.input<{ inputLoading: boolean }>`
    ${({ inputLoading }) =>
        inputLoading &&
        css`
            padding-right: 30px;
        `}
`;

export const StyledStaffItem = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledStaffName = styled.span`
    margin-left: 10px;
    margin-right: 10px;
`;
export const StyledTicketCountItem = styled.span`
    margin-left: auto;
    background-color: ${themeGet("colors.gray500")};
    border-radius: 9999;
    height: 20px;
    width: 30px;
    display: flex;
    color: ${themeGet("colors.white")};
    justify-content: center;
    align-items: center;
    border-radius: 30%;
`;

export const StyledInputWrapper = styled.div`
    padding: 10px 5px;
    position: relative;
`;

export const StyledAssignedButton = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledToggle = styled(({ ...rest }) => (
    <DropdownToggle {...rest} />
))`
    color: #ffff;
`;

export const StyledWrapper = styled.div`
    display: flex;
    margin-left: auto;
`;

export const StyledCloseTicketBtn = styled(({ ...rest }) => (
    <Button {...rest} />
))`
    &.closed-ticket {
        background-color: rgb(131, 146, 165);
    }
    background: ${themeGet("colors.orange")};
    color: #fff;
    border: none;
    min-width: 99px;
    &:hover {
        background: #e16c0a;
    }
    &:focus {
        box-shadow: 0 0 0 0.2rem rgb(95 14 14 / 50%);
        background: ${themeGet("colors.orange")};
    }
`;
